<template>
  <div v-if="items.length >= 2" class="v2026-subtab" role="group" :aria-label="ariaLabel">
    <button v-for="item in items"
            :key="item.key"
            type="button"
            class="v2026-subtab__cell"
            :class="{ 'is-active': item.key === activeKey }"
            :aria-current="item.key === activeKey ? 'true' : null"
            :title="item.label"
            @click="$emit('select', item.key)">
      <span class="v2026-subtab__label">{{ item.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'panel-sub-tab-bar-v2026',
  props: {
    items: {
      type: Array,
      required: true
    },
    activeKey: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: 'ทางลัดไปยังส่วนต่าง ๆ'
    }
  }
}
</script>

<style scoped>
.v2026-subtab {
  display: flex;
  flex: 0 0 auto;
  height: 36px;
  background: var(--v2026-surface, #ffffff);
  border-bottom: 1px solid var(--v2026-border, #e4e7ec);
  margin-top: calc(var(--v2026-sp-4, 16px) * -1);
}

.v2026-subtab__cell {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 var(--v2026-sp-2, 8px);
  border: 0;
  border-radius: var(--v2026-r-tab, 10px);
  background: transparent;
  font-size: var(--v2026-fs-meta, 12px);
  font-weight: 500;
  color: var(--v2026-text-secondary, #667085);
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}

.v2026-subtab__label {
  min-width: 0;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2026-subtab__cell:hover:not(.is-active) {
  /* background: var(--v2026-surface-sunken, #F8FAFC); */
  color: var(--v2026-text, #101828);
}

.v2026-subtab__cell.is-active {
  background: var(--v2026-color-main-soft, #31C1D714);
  color: var(--v2026-text, #101828);
  font-weight: 600;
}
.v2026-subtab__cell.is-active::after {
  content: '';
  position: absolute;
  left: 20%;
  right: 20%;
  bottom: 0;
  height: 2px;
  background: var(--v2026-color-main, #31C1D7);
  border-radius: 2px 2px 0 0;
}
.v2026-subtab__cell.is-active:hover {
  background: rgba(49, 193, 215, 0.12);
}

.v2026-subtab__cell:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
}

@media (prefers-reduced-motion: reduce) {
  .v2026-subtab__cell {
    transition: none;
  }
}
</style>
